import { LineTypeCode } from "@/types";

// LineTypeCode를 위한 룩업 테이블
const lineTypeCodeMap = new Map<string, LineTypeCode>(
  Object.entries(LineTypeCode).map(([key, value]) => [
    value as string,
    LineTypeCode[key as keyof typeof LineTypeCode],
  ])
);

/**
 * 주어진 문자열 코드에 해당하는 LineTypeCode를 반환
 * @param code 검색할 문자열 코드 (예: "LRT-FORWAR")
 * @returns LineTypeCode 열거형 값 또는 undefined (일치하지 않을 경우)
 */
export function useLookupLineTypeCode(code: string): LineTypeCode | undefined {
  return lineTypeCodeMap.get(code);
}
